/* eslint-disable react/jsx-no-bind */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { useQueryParams, useCountry, useModel } from "../../../../hooks";
import Button from "wonderbly-components/lib/Button";
import SelectField from "wonderbly-components/lib/SelectField";
import ProductHeroIIForm from ".././ProductHeroIIForm";
import Modal from "../../../Modal";
import { track } from "src/client/js/analytics/facade";
import { getLocales } from ".././helpers";

const ProductHeroIIButtonCreationFlow = (props) => {
  const country = useCountry();
  const { prismicProduct, eagleProduct } = useModel();
  const { params, setParams, removeParam } = useQueryParams();
  const [creationFlowVisible, setCreationFlowVisible] = useState(
    params.openCreationFlow !== undefined
  );
  const { locales, localeLabel } = getLocales(
    props.productCreationFlow,
    eagleProduct.variants
  );
  const [selectedLocale, setSelectedLocale] = useState(
    locales?.[0]?.value || country.locale
  );

  function updateCreationFlowVisibility(value) {
    value
      ? setParams({ openCreationFlow: "" })
      : removeParam("openCreationFlow");

    setCreationFlowVisible(value);
  }

  function handleCtaClick(e) {
    e.preventDefault();
    updateCreationFlowVisibility(true);
    track("opened_personalisation", {
      category: "Creation Flow",
      label: prismicProduct.main.productId,
    });
  }

  return (
    <div className="ProductHeroII__button-wrap">
      {locales.length > 0 && (
        <SelectField
          id="ProductHeroII__locale-select"
          type="select"
          name="locale-select"
          label={localeLabel}
          options={locales}
          onChange={(e) => setSelectedLocale(e.target.value)}
        />
      )}

      <Button className="ProductHeroII__button" onClick={handleCtaClick}>
        {props.productCtaButtonText}
      </Button>

      <Modal
        fit
        containScroll
        isOpen={creationFlowVisible}
        updateIsOpen={updateCreationFlowVisibility}
      >
        <ProductHeroIIForm
          {...props.productCreationFlow}
          setIsVisible={updateCreationFlowVisibility}
          externalPresetValues={{
            locale: selectedLocale,
          }}
        />
      </Modal>
    </div>
  );
};

ProductHeroIIButtonCreationFlow.propTypes = {
  productCtaButtonText: PropTypes.string,
  productCreationFlow: PropTypes.object,
};

export default ProductHeroIIButtonCreationFlow;
